import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"
import isNumber from "lodash-es/isNumber"

import { axiosClient } from "$/http"

import {
    ECoachingSessionsGroupQueryKey,
    ECoachingSessionsGroupQueryUrl,
    ECoachingSessionsIndividualQueryKey,
    ECoachingSessionsIndividualQueryUrl
} from "@/3514/config"
import type { ICoachingSessionsQueryDto } from "@/3514/types"
import { extractNumberFromQueryKeyPart } from "@/3514/utils"

async function coachingSessionsIndividualFetcher({
    queryKey
}: QueryFunctionContext<ReturnType<typeof ECoachingSessionsIndividualQueryKey>>): Promise<ICoachingSessionsQueryDto> {
    if (!isNumber(extractNumberFromQueryKeyPart(queryKey[1]))) throw new Error("participantId is not a number")

    const { data }: AxiosResponse<ICoachingSessionsQueryDto> = await axiosClient.get(
        ECoachingSessionsIndividualQueryUrl({
            participantId: extractNumberFromQueryKeyPart(queryKey[1])
        })
    )

    return data
}

async function coachingSessionsGroupFetcher({
    queryKey
}: QueryFunctionContext<ReturnType<typeof ECoachingSessionsGroupQueryKey>>): Promise<ICoachingSessionsQueryDto> {
    if (!isNumber(extractNumberFromQueryKeyPart(queryKey[1]))) throw new Error("groupId is not a number")

    const { data }: AxiosResponse<ICoachingSessionsQueryDto> = await axiosClient.get(
        ECoachingSessionsGroupQueryUrl({
            groupId: extractNumberFromQueryKeyPart(queryKey[1])
        })
    )

    return data
}

export { coachingSessionsIndividualFetcher, coachingSessionsGroupFetcher }
